import React
,
 { 
  useEffect, 
  useMemo, 
  useRef } 
  from "react";
//import { useSelector } from "react-redux";
//import { Chart } from "chart.js";
//import { metronic } from "../../_metronic";


import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import interactionPlugin, {Draggable} from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import {  format } from 'date-fns'
import { Table } from "react-bootstrap";
import Alert from '@material-ui/lab/Alert'

import CircularProgress from '@material-ui/core/CircularProgress';


import '@fullcalendar/core/main.css';
//import '../pages/home/main.scss' // webpack must be configured to do this
//import '../pages/home/main.css' // webpack must be configured to do this

import { getSchedulesWO,getSchedulesById,completeTask,getStatus,updateSchedule } from "../crud/auth.crud";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ReactTooltip from 'react-tooltip'
import EditSchedule from '../pages/home/EditSchedule'




export default class CalendarEvents extends React.Component {

calendar = React.createRef();


constructor(props)
{
  super(props);
 
  this.state = {
      schedules:[],
      open:false,
      notes:"",
      patientWDialog:false,
      allSchedules:[],
      isLoading:true,
      totalRecords:'',
      statusId:null,
    };

 
  
}

rowClick =(id) =>{

  getSchedulesById(id).then(response => response.data)
      .then((data) => {
        this.setState({ open:true, schedule: data[0],tStatus: data[0].status,notes: data[0].notes});
       
      })
}

handleDateClick = ({event,el})=>{

  console.log(event,el);
}

handleEventClick = ({ event, el }) => {
        //this.toggle();
        
    //console.log("event :::::",event,el);

    if(event.extendedProps.taskCount===1)
    {
      getSchedulesById(event.id).then(response => response.data)
      .then((data) => {
        this.setState({ open:true, schedule: data[0],tStatus: data[0].status,notes: data[0].notes});
       
      })
    }
    else
    {
        this.setState({patientWDialog:true,patientWName:event.title, patientWId:event.extendedProps.pEntityId,patientWDate:event.extendedProps.startDate });
    }

};

//eventRender(info){
    
  //}

  handleEventPositioned(info) {
  info.el.setAttribute("data-tip",info.event.extendedProps.description);
   ReactTooltip.rebuild();
}

handleDatesRender=(info)=>
{
  //console.log(info);
  //const calendarApi = this.calendar.current.getApi();
  console.log('Current View:', info.view.type);
  if(info.view.type.includes("listYear"))
  {
    let postObj={};
    postObj.datefromstartDate = this.formatDateToYYYYMMDD(info.view.activeStart);
    postObj.datetostartDate = this.formatDateToYYYYMMDD(info.view.activeEnd);
   
    this.dataload(postObj);
  }
  else if(info.view.type.includes("dayGridMonth"))
  {
      let postObj={};
      postObj.datefromstartDate = this.formatDateToYYYYMMDD(info.view.currentStart);
      postObj.datetostartDate = this.formatDateToYYYYMMDD(info.view.currentEnd);
     
      this.dataload(postObj);
  }
  
 
}

filterByStatus= (statusId) => {

  let tempSchedules=[];
  if(statusId!=null)
  {
    //getSchedulesWO().then(response => response.data)
    //.then((data) => {
      
      /*//console.log(this.state.users)
      data.filter(f=> f.statusKey == statusId).map((sch)=>(
          //tempSchedules.push({id: sch.id, title: sch.scheduleType, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
          tempSchedules.push({id: sch.id, title: sch.pEntity[0].firstName + ' ' + sch.pEntity[0].lastName, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
        ))
      this.setState({ schedules: tempSchedules });
      //console.log("didmount");
      //console.log(this.state.schedules);
      */
     // this.eventGrouping(data.filter(f=> f.statusKey == statusId));
     //})
     this.setState({statusId:statusId});
     this.eventGrouping(this.state.allSchedules.filter(f=> f.statusKey == statusId));

  }
  else
  {

    //getSchedulesWO().then(response => response.data)
    //.then((data) => {
      
      /*//console.log(this.state.users)
      data.map((sch)=>(
          //tempSchedules.push({id: sch.id, title: sch.scheduleType, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
          tempSchedules.push({id: sch.id, title: sch.pEntity[0].firstName + ' ' + sch.pEntity[0].lastName, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
        ))
      this.setState({ schedules: tempSchedules });
      //console.log("didmount");
      //console.log(this.state.schedules);
      */
     // this.eventGrouping(data);
     //})
     this.eventGrouping(this.state.allSchedules);
  }

}

 formatDateToYYYYMMDD(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
  
async componentDidMount()
  {
    
    this.dataload(null);

    getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
     // console.log(data);
     });
  }

  async dataload(postObj)
  {
     //let schedules = this.state.schedules;
     let calendarData=[];
     //datefromstartDate":"2025-05-01","datetostartDate":"2025-05-31
 
     //console.log(Date().getMonth());
     this.setState({isLoading:true,totalRecords:''});
 
     
 
 
     if(postObj===null)
     {
      const calendarApi = this.calendar.current.getApi();
      //console.log(calendarApi.getDate());
      const view = calendarApi.view;
      //console.log('Start:', this.formatDateToYYYYMMDD(view.currentStart)); // Start date of current view
      //console.log('End:', this.formatDateToYYYYMMDD(view.currentEnd)); 
      postObj={};
      postObj.datefromstartDate = this.formatDateToYYYYMMDD(view.currentStart);
      postObj.datetostartDate = this.formatDateToYYYYMMDD(view.currentEnd);
     }
 
     await getSchedulesWO(1,postObj)//.then(response => response.data)
     .then(async (response) => {
      // console.log("total page::::",response);
         this.setState({totalRecords:parseInt(response.headers['x-total-page'])*100});
         //console.log("current page:::",response.headers['x-page']);
        // console.log("current page:::",response.headers['x-page']);
         calendarData=response.data;
         let total_pages = parseInt(response.headers['x-total-page']);
         for(let i=2;i<=total_pages;i++)
         {
             await getSchedulesWO(i,postObj)//.then(response => response.data)
             .then((resp1) => {
               calendarData=calendarData.concat(resp1.data);
           })
         }
         //console.log("length cal::::::",calendarData.length);
         this.setState({allSchedules:calendarData,isLoading:false});
         if(this.state.statusId===null)
           this.eventGrouping(calendarData);
          else 
            this.eventGrouping(calendarData.filter(f=> f.statusKey == this.state.statusId));
         
 
      })
    


  }

  next=()=>
  {
    //console.log("next");
    const calendarApi = this.calendar.current.getApi();
    calendarApi.next();
    //console.log(calendarApi.getDate());

      let postObj = {};
      const view = calendarApi.view;
      //console.log('Start:', this.formatDateToYYYYMMDD(view.currentStart)); // Start date of current view
      //console.log('End:', this.formatDateToYYYYMMDD(view.currentEnd)); 
      postObj.datefromstartDate = this.formatDateToYYYYMMDD(view.currentStart);
      postObj.datetostartDate = this.formatDateToYYYYMMDD(view.currentEnd);
      this.dataload(postObj);

  }

  prev=()=>
    {
      //console.log("previous");
      const calendarApi = this.calendar.current.getApi();
      calendarApi.prev();
      //console.log(calendarApi.getDate());
      let postObj = {};
      const view = calendarApi.view;
      //console.log('Start:', this.formatDateToYYYYMMDD(view.currentStart)); // Start date of current view
      //console.log('End:', this.formatDateToYYYYMMDD(view.currentEnd)); 
      postObj.datefromstartDate = this.formatDateToYYYYMMDD(view.currentStart);
      postObj.datetostartDate = this.formatDateToYYYYMMDD(view.currentEnd);
      this.dataload(postObj);
    }

  eventGrouping(data)
  {
    let tempSchedules=[];
      let schedules =[];
      data.map((sch)=>{
          if(sch.startDate !== undefined && sch.startDate !== null)
          { 
            sch.startDateFormatted = format(new Date(sch.startDate), 'yyyy-MM-dd');
            schedules.push(sch);
          }
        })
      



     // console.log(schedules);
      schedules.map((sch)=>{
           let count = data.filter(x=> x.pEntityId === sch.pEntityId && x.startDateFormatted === sch.startDateFormatted).length;
           if(parseInt(count)===1)
           {
              //tempSchedules.push({id: sch.id, title: sch.scheduleType, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
              tempSchedules.push({id: sch.id, title: sch.title, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId,taskCount:count,pEntityId:sch.pEntityId,startDate:sch.startDate})
           }
           else
           {
              if(tempSchedules.filter(x=> x.pEntityId === sch.pEntityId && x.date === sch.startDateFormatted).length===0)
              {
                tempSchedules.push({id: sch.id, title: sch.title + ", " + count, date: sch.startDateFormatted, backgroundColor: '#ccff00',description: sch.scheduleType, borderColor: '#ccff00', textColor:'white',key:sch.pEntityId,taskCount:count,pEntityId:sch.pEntityId,startDate:sch.startDateFormatted})    
              }
           }
          
        })

      //console.log("didmount",tempSchedules);
      this.setState({ schedules: tempSchedules,isLoading:false });
      //console.log("didmount");
      //console.log(this.state.schedules);
     
  }

  handleClose = async () =>
  {
    let tempSchedules=[];
    this.setState({open:false,isLoading:true});
    //getSchedulesWO().then(response => response.data)
    //.then((data) => {
      
      /*//console.log(this.state.users)
      data.map((sch)=>(
          //tempSchedules.push({id: sch.id, title: sch.scheduleType, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
          tempSchedules.push({id: sch.id, title: sch.pEntity[0].firstName + ' ' + sch.pEntity[0].lastName, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
        ))
      this.setState({ schedules: tempSchedules });
      //console.log("didmount");
      //console.log(this.state.schedules);
      */
    //    this.eventGrouping(data);
     //})
      //let schedules = this.state.schedules;
      const calendarApi = this.calendar.current.getApi();
      //calendarApi.prev();
      //console.log(calendarApi.getDate());
      let postObj = {};
      const view = calendarApi.view;
      //console.log('Start:', this.formatDateToYYYYMMDD(view.currentStart)); // Start date of current view
      //console.log('End:', this.formatDateToYYYYMMDD(view.currentEnd)); 
      postObj.datefromstartDate = this.formatDateToYYYYMMDD(view.activeStart);
      postObj.datetostartDate = this.formatDateToYYYYMMDD(view.activeEnd);
      this.dataload(postObj);
    
   //**** */   
   //   let calendarData=[];
      
   // await getSchedulesWO()//.then(response => response.data)
   // .then(async (response) => {
     // console.log("total page::::",response);
        //console.log("total page::::",response.headers['x-total-page']);
        //console.log("current page:::",response.headers['x-page']);
       // console.log("current page:::",response.headers['x-page']);
    //    calendarData=response.data;
   //     let total_pages = parseInt(response.headers['x-total-page']);
   //     for(let i=2;i<=total_pages;i++)
   //     {
   //         await getSchedulesWO(i,{})//.then(response => response.data)
    //        .then((resp1) => {
   //           calendarData= calendarData.concat(resp1.data);
   //       })
   //     }

    //    this.setState({allSchedules:calendarData});
    //    this.eventGrouping(calendarData);

    // })
     
  }

  handlePatientWDialogClose = () =>
  {
    let tempSchedules=[];
    this.setState({patientWDialog:false});
   
  }

  /*completeSchedule = () =>
  {
     this.state.schedule.status=this.state.tStatus;
     //this.state.schedule.percentage = 100;
     this.state.schedule.notes  = this.state.notes;
     if(this.state.tStatus=="green")
     {
        this.state.schedule.percentage = 100;
     }
     else if(this.state.tStatus=="red")
     {
        this.state.schedule.percentage = 0;
     }
      
      completeTask(this.state.schedule).then(response => response.data)
      .then((data) => {
        
                let tempSchedules=[];
                getSchedulesWO().then(response => response.data)
                .then((data) => {
                  
                  //console.log(this.state.users)
                  data.map((sch)=>(
                      //tempSchedules.push({id: sch.id, title: sch.scheduleType, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
                      tempSchedules.push({id: sch.id, title: sch.title, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white',key:sch.scheduleId})
                    ))
                  this.setState({ schedules: tempSchedules,open:false });
                  //console.log("didmount");
                  //console.log(this.state.schedules);
                 })

      })
     
  }*/

   

  drop = info => 
      {
        alert(info.draggedEl.id);
      }
  /*
  eventRender(info){
    var tooltip = new Tooltip(info.el, {
      title: info.event.extendedProps.description,
      placement: 'top',
      trigger: 'hover',
      container: 'body'
    });
  }*/
  
  eventDrop = info =>
      {
        //console.log("drag :::::",info.event);
        if(info.event.extendedProps.taskCount===1)
        {
        const string = info.event.title;
        let scheduleKey='';
        //const stringId = string.split(' - ')[0];
        const id = info.event.id;
       // console.log(string+ "------" + id + "======" + info.event.start);
         this.state.schedules.filter(f=> f.id == id).map((sch)=>(
          scheduleKey = sch.key
          ))
        let schedule = {
                     
                      startDate:info.event.start
                      
                     
                   };
                    updateSchedule("schedule",scheduleKey,schedule
                      )
                      .then(resp => {
                        //props.register(accessToken);
                      })
                      .catch(() => {
                      });

        //this.props.schedulesEvent(id, info.event.start, info.event.end)
      }
      };

  /*undoSchedule = () =>
  {
     this.state.schedule.status="red";
     this.state.schedule.percentage = 0;
     this.state.schedule.notes  = this.state.notes;
      
      completeTask(this.state.schedule).then(response => response.data)
      .then((data) => {
        
          let tempSchedules=[];
                getSchedulesWO().then(response => response.data)
                .then((data) => {
                  
                  //console.log(this.state.users)
                  data.map((sch)=>(
                      //tempSchedules.push({id: sch.id, title: sch.scheduleType, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white'})
                      tempSchedules.push({id: sch.id, title: sch.title, date: sch.startDate, backgroundColor: sch.status,description: sch.scheduleType, borderColor: sch.status, textColor:'white'})
                    ))
                  this.setState({ schedules: tempSchedules,open:false });
                  //console.log("didmount");
                  //console.log(this.state.schedules);
                 })

      })
     
  }*/






  render()
  {
   

    //console.log(this.state.schedules);
    //console.log("open status=="+this.state.open);
    return (
      <div className="kt-portlet kt-portlet--height-fluid">
          
          <div className="kt-portlet__body">
            <div className="row">
                {this.state.mStatus!=null && this.state.mStatus.map((status)=>(
                  <div className="btn-toolbar kt-margin-l-20" key={status.id}>
                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
                      <button onClick={()=>this.filterByStatus(status.statusKey)} className="btn btn-success btn-elevate btn-pill btn-sm" style={{background: status.statusId, borderColor:status.statusId}}>
                        {status.statusName}
                      </button></div>
                  </div>
                  ))}
                  <div className="btn-toolbar kt-margin-l-20">
                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
                      <button onClick={()=>this.filterByStatus(null)} className="btn btn-success btn-pill btn-sm" style={{background:'#2c3e50',borderColor:'#2c3e50'}} >
                        Show All
                      </button></div>
                  </div>
            </div>

            <div className="kt-space-20" />
            <div className="row"> 
            {this.state.isLoading &&
            <div style={{alignItems: "center",display: 'flex', justifyContent: 'center',height: "100vh", width: "100vw"}}>
             
              <Alert icon={ <CircularProgress size={15} />}>Fetching {this.state.totalRecords} records from server. Please wait...</Alert>
            </div>
            }
         
              <FullCalendar style={{width:'100%'}} defaultView="dayGridMonth" ref={this.calendar}  header={{
          left: "today cbprev,cbnext",
          center: "title",
          right: "dayGridDay,dayGridWeek,dayGridMonth,listYear",

        }} 
        datesRender={this.handleDatesRender}
        activeStart = {1}

        customButtons={{
          cbprev: {
            text: '<previous',
            click: ()=>this.prev(),
          },
          cbnext: {
            text: 'next>',
            click: ()=>this.next(),
          },
        }}
        
        buttonText={{
            today:    'Today',
            month:    'Month',
            week:     'Week',
            day:      'Day',
            list:     'Year'
          }}  
         
          
          plugins={[ dayGridPlugin,listPlugin,interactionPlugin ]} 
          events={this.state.schedules} 
          //events={(fetchInfo, successCallback, failureCallback) => this.getCalendarData(fetchInfo, successCallback, failureCallback)        }
          eventClick={this.handleEventClick}

         //eventRender={this.eventRender}
          editable={true}
          selectable={true}
          dayMaxEvents={true}
          displayEventTime={false}
          drop={this.drop}
          eventDrop={this.eventDrop}
          eventPositioned={this.handleEventPositioned}
              dateClick={this.handleDateClick}
        
              />
        
        </div>

        </div>
         {this.state.schedule != null &&
        <Dialog  fullWidth={true} maxWidth={'xs'} open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
        
        {this.state.schedule.pEntity.map((pen)=> (
          <>

        <DialogTitle id="form-dialog-title"> <Link
                    to={{pathname:"/viewpatient", search:"?id="+pen.id+"&key="+pen.pEntityId,data: pen}} target="_blank"
                    >{pen.firstName + " " + pen.lastName} - {this.state.schedule.scheduleType}</Link></DialogTitle>
        <DialogContent>
          <EditSchedule schedule={this.state.schedule} />
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          
          
          
        </DialogActions>
          </>
        ))}
      </Dialog>
    }

    {this.state.patientWId != null &&
        <Dialog  fullWidth={true} maxWidth={'xs'} open={this.state.patientWDialog} onClose={this.handlePatientWDialogClose} aria-labelledby="form-dialog-title">
        
        
          

        <DialogTitle id="form-dialog-title"> {this.state.patientWName + " - "} {format(new Date(this.state.patientWDate),'MM/dd/yyyy')} </DialogTitle>
        <DialogContent>
        <Table>
                  
                  <tbody>
          {this.state.allSchedules.filter(x=>x.pEntityId===this.state.patientWId && x.startDateFormatted=== this.state.patientWDate).map((sch)=> (
               <tr onClick={()=>this.rowClick(sch.id)} key={sch.id}>
                  <td>
                      {/*<button className="btn btn-success btn-sm" style={{background: sch.status, 'border-color':sch.status,'width':'100%'}}>{sch.pEntity[0].firstName + ' ' + sch.pEntity[0].lastName}</button>*/}
                      <button className="btn btn-success btn-sm" style={{background: sch.status, 'border-color':sch.status,'width':'100%'}}>{sch.title}</button>
                  </td>
                </tr>
            ))}
              </tbody>
              </Table>
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handlePatientWDialogClose} color="primary">
            Cancel
          </Button>
          
          
          
        </DialogActions>
         
      </Dialog>
    }
      </div>
       
    );
  }
  
}

